import { render, staticRenderFns } from "./SiteIntakeStatus.vue?vue&type=template&id=2c6e0ea3"
import script from "./SiteIntakeStatus.vue?vue&type=script&lang=ts"
export * from "./SiteIntakeStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports